import PropTypes from 'prop-types';

const ChevronLeftIcon = ({
  size = '24',
  color = 'currentColor',
  opacity = '.75',
  onClick,
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" onClick={onClick}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 24V0h24v24z" />
        <path
          fill={color}
          fillOpacity={opacity}
          fillRule="nonzero"
          d="M14.69 16.161a1.1 1.1 0 0 1 0 1.525 1.051 1.051 0 0 1-1.5 0l-4.88-4.929a1.077 1.077 0 0 1 0-1.514l4.88-4.929a1.051 1.051 0 0 1 1.5 0 1.077 1.077 0 0 1 0 1.514l-4.125 4.167 4.124 4.166z"
        />
      </g>
    </svg>
  );
};

ChevronLeftIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  opacity: PropTypes.string,
  onClick: PropTypes.func,
};

export default ChevronLeftIcon;
